import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
import { ElSelect, ElOption } from 'element-plus';
import 'element-plus/es/components/select/style/css'
import 'element-plus/es/components/option/style/css'

import { Field } from 'vee-validate';
import { useAttrs } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ISelect',
    props: /*@__PURE__*/ _mergeModels({
        name: {},
        items: {
            default: ()=>[]
        },
        size: {
            default: ''
        },
        icon: {
            default: ''
        },
        width: {
            default: ''
        }
    }, {
        "modelValue": {},
        "modelModifiers": {}
    }),
    emits: [
        "update:modelValue"
    ],
    setup (__props) {
        const innerValue = _useModel(__props, "modelValue");
        const attrs = useAttrs();
        return (_ctx, _cache)=>{
            return _openBlock(), _createBlock(_unref(Field), {
                modelValue: innerValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>innerValue.value = $event),
                name: __props.name
            }, {
                default: _withCtx(({ field, handleChange, errors })=>[
                        _createElementVNode("div", null, [
                            _createVNode(_unref(ElSelect), _mergeProps({
                                "model-value": field.value,
                                "empty-values": [
                                    undefined,
                                    null
                                ],
                                size: __props.size === 'medium' ? '' : __props.size,
                                "fallback-placements": [
                                    'bottom-start',
                                    'top-start'
                                ],
                                class: [
                                    __props.size === 'medium' && _ctx.$style.medium,
                                    __props.icon === 'plus' && _ctx.$style.plus,
                                    _unref(attrs).disabled && _ctx.$style.disabled,
                                    errors[0] && 'error'
                                ],
                                style: __props.width && {
                                    width: `${__props.width}px`
                                }
                            }, _unref(attrs), {
                                "onUpdate:modelValue": handleChange
                            }), {
                                default: _withCtx(()=>[
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item)=>{
                                            return _openBlock(), _createBlock(_unref(ElOption), {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                            }, null, 8, [
                                                "label",
                                                "value"
                                            ]);
                                        }), 128))
                                    ]),
                                _: 1
                            }, 16, [
                                "model-value",
                                "size",
                                "class",
                                "style",
                                "onUpdate:modelValue"
                            ]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            errors[0] ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(_ctx.$style.errorWrap)
                            }, [
                                _createElementVNode("p", {
                                    class: _normalizeClass(_ctx.$style.error)
                                }, _toDisplayString(errors[0]), 3)
                            ], 2)) : _createCommentVNode("", true)
                        ])
                    ]),
                _: 1
            }, 8, [
                "modelValue",
                "name"
            ]);
        };
    }
});
